import isFn from 'utils/predicates/function/isFn.util';
import isPositiveInteger from 'utils/predicates/number/isPositiveInteger.util';

const withIndices = (_, index) => index;

const createFullArray = (options) => {
  const size = options?.size;

  if (!isPositiveInteger(size)) return [];
  if (isFn(options?.map)) return new Array(size).fill(void 1).map(options?.map);
  if (options?.indices) return new Array(size).fill(void 1).map(withIndices);

  return new Array(size).fill(options?.item);
};

export default createFullArray;
